import { render, staticRenderFns } from "./StblIndexView.vue?vue&type=template&id=44bdf4ed&scoped=true"
import script from "./StblIndexView.vue?vue&type=script&lang=js"
export * from "./StblIndexView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bdf4ed",
  null
  
)

export default component.exports